module.exports = __webpack_public_path__ + "img/4.49db064a.png";